// Order matters
import { BootstrapOptions, Module } from 'owa-bootstrap';
import 'owa-application';
import { CalendarModule, getCalendarHeaderProps } from 'owa-calendar-surface-view';
// TODO VSO 82257: Explicitly call code to set up selected calendars in boot rather than relying on 'owa-calendar-module-selected-calendars-user-config' orchestrators
import 'owa-calendar-module-selected-calendars-user-config';
import { calendarModuleNameText } from './strings.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { addinIconsRegistration } from 'owa-addins-icons';
import { calendarIconsRegistration } from 'owa-calendar-icons';
import { controlIconRegistration } from 'owa-control-icons';
import { initializeRoutes, routerOptions } from './routing/calendarRoutes';
import { mailIconsRegistration } from 'owa-mail-icons';
import { OwaWorkload } from 'owa-workloads';
import { stashCalendarFoldersFromSessionData } from 'owa-calendarsapi-outlook/lib/services/calendarFoldersFromSessionData';
import { getAnalyticOptions } from 'owa-shared-analytics';
import 'owa-attachment-preview-initialization/lib/utils/initializeAttachmentPreviewInPopOut';
import { SessionData } from 'owa-service/lib/types/SessionData';
import initializeState from './initializeState';
import { lazySetupCalendarFunctionalBoot } from 'owa-calendar-post-boot';
import { verifyAndSetOptionValues } from 'owa-outlook-service-option-store';
import { getPrimeBootSettingsOptionsValues } from 'owa-session-store';
import { isOpx } from 'owa-opx';
import { isOfflineEnabled } from 'calendar-offline-services';
import { initBootCalendarCloudSettings } from 'owa-calendar-cloud-settings/lib/bootIndex';
import { SearchBoxContainerHandle } from 'owa-search';
import { SkipLinkPlaceholderHandle } from 'owa-skip-link';
import { BootStrategies } from 'owa-shared-start';

// TODO: VSO #88707 Separate module vs surface concerns in Calendar module
// Right now view type and surface init are too entangled, leading to module bootstrap weirdness
// where view-type is initially resolved in `initializeSurfaceOptions`, and then potentially
// overridden by view route handlers later on in the boot flow

// Order is important, do not mess with it :)
export function getCalendarBootstrapOptions(
    sessionPromise: Promise<SessionData | undefined>,
    strategies?: BootStrategies
): Promise<BootstrapOptions> {
    const isOffline = isOfflineEnabled();
    let app = isOffline ? 'calendarOffline' : 'mail';
    if (isOpx()) {
        app = 'calendarOpx';
        if (isOffline) {
            app += 'Offline';
        }
    }

    return Promise.resolve({
        initializeState: sessionData => {
            stashCalendarFoldersFromSessionData(sessionData);
            const options = getPrimeBootSettingsOptionsValues();
            verifyAndSetOptionValues(options);
            initBootCalendarCloudSettings();
            initializeState();
        },
        analyticsOptions: getAnalyticOptions(),
        sessionPromise,
        registerRoutes: initializeRoutes,
        routerOptions: routerOptions,
        getModuleName: () => loc(calendarModuleNameText),
        workload: OwaWorkload.Calendar,
        iconFonts: [
            addinIconsRegistration,
            controlIconRegistration,
            calendarIconsRegistration,
            mailIconsRegistration,
        ],
        swConfig: {
            app,
        },
        postLazyAction: lazySetupCalendarFunctionalBoot,
        waitForDateTimeStore: true,
        appModuleProps: {
            module: Module.Calendar,
            renderModule: (
                searchBoxRef: React.RefObject<SearchBoxContainerHandle>,
                skipLinkRef: React.RefObject<SkipLinkPlaceholderHandle>
            ) => <CalendarModule searchBoxRef={searchBoxRef} skipLinkRef={skipLinkRef} />,
            getHeaderInfo: getCalendarHeaderProps,
        },
        strategies,
    });
}
